var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHomepage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 79,
    viewBox: "0 0 8 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64645 78.3536C3.84171 78.5488 4.15829 78.5488 4.35355 78.3536L7.53553 75.1716C7.7308 74.9763 7.7308 74.6597 7.53553 74.4645C7.34027 74.2692 7.02369 74.2692 6.82843 74.4645L4 77.2929L1.17157 74.4645C0.976311 74.2692 0.659728 74.2692 0.464466 74.4645C0.269204 74.6597 0.269204 74.9763 0.464466 75.1716L3.64645 78.3536ZM3.5 0.5V78H4.5V0.5H3.5Z",
    fill: "#4800BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHomepage);
export default __webpack_public_path__ + "static/media/arrow-homepage.8f51962de49322ea55166c4bdbcd68e5.svg";
export { ForwardRef as ReactComponent };